module.exports = __webpack_public_path__ + "img/economicIndicators.637e2d91.png";